/* Cletya — ajustements propres a la tablette.
 *
 * L'accordeon « Technical Specifications » est ouvert par defaut. Sur tablette
 * il pousse tout le contenu vers le bas (Theo, 2026-09-18). Le reglage
 * open_by_default du theme n'est pas responsive, d'ou ce complement.
 *
 * Pourquoi un fichier a part plutot qu'un <script> dans le bloc : un <script>
 * insere via innerHTML — ce que fait Shopify pour du custom_liquid — n'est
 * JAMAIS execute par le navigateur. La premiere version, placee dans le bloc,
 * etait bien presente dans le DOM et totalement inerte.
 */
(function () {
  var TABLETTE = '(min-width: 750px) and (max-width: 1099px)';
  var MARQUE = 'cletyaOuvertParUtilisateur';

  function estSpecs(el) {
    var s = el && el.querySelector ? el.querySelector('summary') : null;
    return !!(s && /technical\s+specification/i.test(s.textContent));
  }
  function trouver() {
    var cible = null;
    document.querySelectorAll('details').forEach(function (el) {
      if (estSpecs(el)) cible = el;
    });
    return cible;
  }
  function appliquer() {
    var bloc = trouver();
    if (!bloc) return;
    if (window.matchMedia(TABLETTE).matches && bloc.open && !bloc.dataset[MARQUE]) {
      bloc.removeAttribute('open');
    }
  }

  // Une ouverture volontaire du visiteur ne doit pas etre annulee derriere lui.
  //
  // On ecoute le CLIC sur le resume, pas l'evenement 'toggle' : le theme ouvre et
  // ferme l'accordeon par programme au chargement, ce qui declenche 'toggle' sans
  // aucune action humaine. La premiere version marquait donc l'accordeon comme
  // « ouvert par le visiteur » avant meme qu'il ait vu la page, et refusait ensuite
  // de le fermer — le garde-fou neutralisait la fonction qu'il devait proteger.
  document.addEventListener('click', function (e) {
    if (!e.isTrusted || !e.target || !e.target.closest) return;
    var resume = e.target.closest('summary');
    if (!resume) return;
    var bloc = resume.parentElement;
    if (bloc && bloc.tagName === 'DETAILS' && estSpecs(bloc) && !bloc.open) {
      bloc.dataset[MARQUE] = '1';
    }
  }, true);

  function surveiller(bloc) {
    if (!bloc || !window.MutationObserver) return;
    // Le theme rouvre l'accordeon de façon differee (mesure le 2026-09-18 :
    // ferme a 3,5 s, rouvert a 4 s). On contre cette reouverture, mais SEULEMENT
    // le temps du chargement : au-dela, la main revient au visiteur. Une
    // surveillance permanente l'empechait purement et simplement d'ouvrir le bloc.
    var obs = new MutationObserver(function () {
      if (!bloc.dataset[MARQUE]) appliquer();
    });
    obs.observe(bloc, { attributes: true, attributeFilter: ['open'] });
    var rendreLaMain = function () { obs.disconnect(); };
    setTimeout(rendreLaMain, 8000);
    bloc.addEventListener('click', rendreLaMain, { once: true, capture: true });
  }

  function demarrer() {
    appliquer();
    var bloc = trouver();
    if (bloc) {
      surveiller(bloc);
    } else if (window.MutationObserver) {
      // Le bloc peut arriver tard : on attend son apparition, puis on surveille.
      var obsDoc = new MutationObserver(function () {
        var b = trouver();
        if (b) { obsDoc.disconnect(); appliquer(); surveiller(b); }
      });
      obsDoc.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { obsDoc.disconnect(); }, 8000);
    }
    window.matchMedia(TABLETTE).addEventListener('change', appliquer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
